import i18n from '@/plugins/i18n';
import {
  BYTES_TO_MB_CONVERSION_VALUE,
  MS_TO_SECONODS_CONVERSION_VALUE,
} from '@/utils/templates/databaseTemplate/database.constants';
const databaseMSGraphs = {
  lineCharts: [
    {
      width: '48%',
      title: i18n.global.t('dbm.buffer-pool-size-per-database-in-bytes'),
      header: {
        title: i18n.global.t('dbm.bufferPoolsizePerDatabase'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#ff3d3d'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_bufferpool_size_per_database_in_bytes',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.mb'),
      },
      aggregation: '/',
      aggregationNum: BYTES_TO_MB_CONVERSION_VALUE,
    },
    {
      width: '48%',
      header: {
        title: i18n.global.t('dbm.IOStall'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#00c3a5'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_io_stall_in_milliseconds',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.seconds'),
      },
      aggregation: '/',
      aggregationNum: MS_TO_SECONODS_CONVERSION_VALUE,
    },
    {
      width: '48%',
      title: i18n.global.t('dbm.transaction-log-growth'),
      header: {
        title: i18n.global.t('dbm.transaction-log-growth'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#ee2be1'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_log_transaction_growth',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.number-of-expansions'),
      },
      labels: {
        xAxis: i18n.global.t('dbm.time'),
        yAxis: i18n.global.t('dbm.number-of-expansions'),
      },
    },
    {
      width: '48%',
      header: {
        title: i18n.global.t('dbm.pageFileAvailable'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#0090ff'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_page_file_available',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.mb'),
      },
      aggregation: '/',
      aggregationNum: BYTES_TO_MB_CONVERSION_VALUE,
    },
    {
      width: '100%',
      header: {
        title: i18n.global.t('dbm.pageFileTotal'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#ff8022'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_page_file_total',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.mb'),
      },
      aggregation: '/',
      aggregationNum: BYTES_TO_MB_CONVERSION_VALUE,
    },
  ],
};

export default databaseMSGraphs;
